'use client';
import Footer from './Footer';
import Image from 'next/image';
import { useSearchParams } from 'next/navigation';
import { useRequest } from 'ahooks';
import { useEffect, useState } from 'react';
import * as api from '../api';
import Loading from '@/components/Loading';
import { getImageURL } from '@/utils/helper';

export default function Index({clueSourceCode}: {clueSourceCode?: string}) {
  const id = useSearchParams().get('id');
  const spec = useSearchParams().get('spec');
  const groupId = useSearchParams().get('groupId');
  const { data, loading } = useRequest(api.getDetailApi, { manual: false, defaultParams: [{ shopId: id, seriesId: spec }] });
  const [specList, setSpecList] = useState<api.SpecDetail[]>([]);
  const [skuInfo, setSkuInfo] = useState<api.SkuInfo>({});
  const [carSkuList, setCarSkuList] = useState<api.SpecSkuDetail[]>([]);
  const [interiorColorList, setInteriorColorList] = useState<api.InteriorColor[]>([]);

  useEffect(() => {
    const price = `${data?.minPrice ?? '--'}~${data?.maxPrice ?? '--'}`
    setSkuInfo({ ...skuInfo, carImg: data?.wareThumbnail, price, seriesName: data?.seriesName });
    setSpecList(data?.specList || []);
  }, [data]);

  function onSeletecSpec(value?: any) {
    setCarSkuList(value?.carSkuList || []);
    setInteriorColorList([]);
    const price = `${data?.minPrice ?? '--'}~${data?.maxPrice ?? '--'}`;
    setSkuInfo({
      ...skuInfo,
      specName: value.specName,
      specId: value.id,
      carImg: value?.specThumbnail,
      specImg: value?.specThumbnail,
      price,
      carName: '',
      exteriorColor: '',
      exteriorColorId: undefined,
      interiorColor: '',
      interiorColorId: undefined,
    });
  }

  async function onSelectExColor(value?: any) {
    if (value?.productId === skuInfo?.exteriorColorId) {
      return;
    }
    const carName = `${skuInfo.specName}  ${value.exteriorColor}`;
    const specImg = skuInfo.specImg;
    const price = `${data?.minPrice ?? '--'}~${data?.maxPrice ?? '--'}`;
    setSkuInfo({
      ...skuInfo,
      exteriorColor: value?.exteriorColor,
      exteriorColorId: value?.productId,
      carName,
      carImg: value?.appearImg || specImg,
      interiorColor: '',
      interiorColorId: undefined,
      price,
    });
    const res = await api.getMaterialApi({ specId: skuInfo.specId, shopId: id, appearColor: value?.exteriorColor });
    setInteriorColorList(res || []);
  }

  function onSelectInColor(value?: any) {
    setSkuInfo({ ...skuInfo, interiorColor: value?.interiorColor, interiorColorId: value?.id, price: value?.dealerRetailPrice });
  }

  if (loading) {
    return <Loading />
  }
  return (
    <div className="bg-[#f4f6fa] dark:bg-[#0a0a0a] flex flex-col justify-between h-screen">
      <div className="flex-auto overflow-scroll">
        <div
          className="bg-white dark:bg-[#171717] flex items-center p-[15px] after:content-['']
            after:block after:absolute after:bottom-0 after:left-0 after:w-full after:h-px after:bg-[rgba(238,238,238,1)] after:origin-bottom after:scale-y-50 relative"
        >
          <div>
            <Image width={95} height={57} style={{ width: 90, height: 'auto' }} alt="" src={getImageURL(skuInfo.carImg || '')} />
          </div>
          <div className="flex flex-col ml-[15px]">
            <span className="text-lg text-[#ff921c]">{skuInfo.price}元</span>
            <span className="text-sm text-[#333] dark:text-white pt-[5px]">{skuInfo?.seriesName || '车系'}</span>
            <span className="text-xs text-[#666] pt-[5px]">{skuInfo.carName || '选择 车型 颜色'}</span>
          </div>
        </div>

        <div className="bg-white dark:bg-[#171717] flex flex-col p-[15px]">
          <span className="text-[15px] text-[#333] dark:text-white">车型</span>
          <div>
            {specList?.map(v => (
              <span
                onClick={() => onSeletecSpec(v)}
                key={v.id}
                className={`inline-block pl-[24px] pr-[24px] pt-[5px] pb-[5px] 
                  rounded-[24.5px] text-sm mr-[20px] mt-[20px] ${skuInfo.specId === v.id ? 'bg-[#ff921c] text-[#fff]' : 'bg-[#F9F9F9] text-[#666]'}`}
              >
                {v?.specName}
              </span>
            ))}
          </div>
        </div>

        {carSkuList?.length ? (
          <div className="bg-white dark:bg-[#171717] flex flex-col p-[15px]">
            <span className="text-[15px] text-[#333] dark:text-white">车身颜色</span>
            <div>
              {carSkuList?.map(v => (
                <span
                  onClick={() => onSelectExColor(v)}
                  key={v.productId}
                  className={`inline-block pl-[24px] pr-[24px] pt-[5px] pb-[5px] rounded-[24.5px] text-sm 
                    mr-[20px] mt-[20px] ${skuInfo.exteriorColorId === v.productId ? 'bg-[#ff921c] text-[#fff]' : 'bg-[#F9F9F9] text-[#666]'}`}
                >
                  {v?.exteriorColor}
                </span>
              ))}
            </div>
          </div>
        ) : null}

        {interiorColorList.length && skuInfo.exteriorColorId ? (
          <div className="bg-white dark:bg-[#171717] flex flex-col p-[15px]">
            <span className="text-[15px] text-[#333] dark:text-white">内饰颜色</span>
            <div>
              {interiorColorList.map(v => (
                <span
                  onClick={() => onSelectInColor(v)}
                  key={v.id}
                  className={`inline-block pl-[24px] pr-[24px] pt-[5px] pb-[5px] 
                    rounded-[24.5px] text-sm mr-[20px] mt-[20px] ${skuInfo.interiorColorId === v.id ? 'bg-[#ff921c] text-[#fff]' : 'bg-[#F9F9F9] text-[#666]'}`}
                >
                  {v.interiorColor}
                </span>
              ))}
            </div>
          </div>
        ) : null}
      </div>
      <Footer groupId={(groupId && +groupId) || undefined} clueSourceCode={clueSourceCode} />
    </div>
  );
}
